(function () {
  'use strict';

  angular.module('sempraWebapp').filter('zeroPaddingFilter', zeroPadding);

  /** @ngInject */
  function zeroPadding() {
    return function (input, n) {
      if (!input) {
        return (input = '00');
      } else if (input.length >= n) {
        return input;
      }
      var zeros = '0'.repeat(n);
      return (zeros + input).slice(-1 * n);
    };
  }
})();
